import { Navigate, Route } from 'react-router-dom'
import { ShipperPortalRoute } from '../../routes/ShipperPortalRoute'
import { lazy } from 'react'

const MotherComponent = lazy(
    () =>
        import(
            /* webpackChunkName: 'MotherComponent' */ 'modules/MotherComponent'
        )
)
const ShipperPortalOrders = lazy(
    () =>
        import(
            /* webpackChunkName: 'ShipperPortalOrders' */ 'shipperPortal/modules/Orders'
        )
)
const Partners = lazy(
    () =>
        import(
            /* webpackChunkName: 'Partners' */ 'shipperPortal/modules/Partners'
        )
)
const PartnerDetails = lazy(
    () =>
        import(
            /* webpackChunkName: 'PartnerDetails' */ 'shipperPortal/modules/PartnerDetails'
        )
)
const OrderDetails = lazy(
    () =>
        import(
            /* webpackChunkName: 'OrderDetails' */ 'shipperPortal/modules/OrderDetails'
        )
)
const ShipperPortalPayables = lazy(
    () =>
        import(
            /* webpackChunkName: 'ShipperPortalPayables' */ 'shipperPortal/modules/Payables'
        )
)

const ShipperWilson = lazy(
    () =>
        import(
            /* webpackChunkName: 'ShipperWilson' */ 'shipperPortal/modules/ShipperWilson'
        )
)

const Settings = lazy(
    () =>
        import(
            /* webpackChunkName: 'Settings' */ 'shipperPortal/modules/Settings'
        )
)

const AddressBookEntries = lazy(
    () =>
        import(
            /* webpackChunkName: 'AddressBookEntries' */ 'shipperPortal/modules/AddressBookEntries'
        )
)

const Home = lazy(
    () => import(/* webpackChunkName: 'Home' */ 'shipperPortal/modules/Home')
)

const Knowledge = lazy(
    () =>
        import(
            /* webpackChunkName: 'Knowledge' */ 'shipperPortal/modules/Knowledge'
        )
)

const Planning = lazy(
    () => import(/* webpackChunkName: 'Planning' */ 'modules/Planning')
)

const Quoting = lazy(
    () => import(/* webpackChunkName: 'Quoting' */ 'modules/Quoting')
)

export const ShipperPortalRoutes = () => {
    return (
        <Route path="sp" element={<ShipperPortalRoute />}>
            <Route element={<MotherComponent />}>
                <Route
                    index
                    element={
                        <Navigate replace to="/sp/home" state={{ from: '/' }} />
                    }
                />
                <Route path="shipments" element={<ShipperPortalOrders />} />
                <Route path="shipments/:id" element={<OrderDetails />} />
                <Route path="partners" element={<Partners />} />
                <Route path="partners/:id" element={<PartnerDetails />} />
                <Route path="payables" element={<ShipperPortalPayables />} />
                <Route path="settings" element={<Settings />} />
                <Route path="addressBook" element={<AddressBookEntries />} />
                <Route path="w/:chatId" element={<ShipperWilson />} />
                <Route path="home" element={<Home />} />
                <Route path="knowledge" element={<Knowledge />} />
                <Route path="planning" element={<Planning />} />
                <Route path="quoting" element={<Quoting />} />
            </Route>
        </Route>
    )
}
